module.exports = {
  "id": "finish-line",
  "color": "blue",
  "title": "finish line",
  "icon": "finish-line",
  "category": "rules",
  "searchTags": ["win","goal","object","game"],
  "exposedVariables": [
    {
      "tooltip":"Set which piece must touch this piece to win",
      "variableName": "piece to win",
      "spriteName": "$glitch_target",
      "value": 1,
      "input": {
        "type": "sprite",
        "id": "piece-to-win-sprite-selector",
        "max": 5,
        "step": 0.1,
        "min": "0.1"
      }
    }
  ],
  "info": [
    {
      "text": "When the player piece touches the finish-line, load the next level",
      "image": "provision/glitches/finish-line/finish-line.gif"
    }
  ],
  "codeImage": "provision/glitches/finish-line/finish-line.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/finish-line/finish-line.svg"
};